import React, { memo, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Container, Row, Col, Form, Button, Modal, InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { tarjetaArticulo } from './componentes';
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion';
import { SiteRutas } from "../../../request/RutasConfig";
import { formatearCantidad, countDecimals, validarInt } from '../../../components/Util/Util.js';
import { Modificar_Detalle_Orden_Articulo_Validado_Request } from "../../../request/SubOrdenDetalleRequest";
import { Validar_Articulo_Despacho_Request } from "../../../request/ArticuloRequest";

class PickingDetalle extends Component {
    state = {
        filtroArticulos: {
            selected: "categoria", options: [
                { value: "categoria", label: "Categoría" },
                { value: "ubicacion", label: "Ubicación" }
            ]
        },
        confirmoLectura: false,
        showModalValidacion: false,
        codigoValidar: '',
        articuloActual: ''
    }

    onChangeCantidadProducto = (producto, evento) => {
        try {

            if (this.props.validarArticuloDespacho && !producto.Detalle_Articulo_Validado) {
                throw 'Debe validar el código del artículo presionando el botón "+".';
            }

            let { value } = evento.target;
            let orden = Object.assign({}, this.props.seleccion.orden);

            orden.productos.forEach(x => {
                if (JSON.stringify(x) === JSON.stringify(producto)) {
                    if (isNaN(value) || value.length === 0) {
                        value = "0";
                    }

                    if (value.includes("e")) {
                        value = value.replace("e", "");
                    }

                    let isValid = value >= 0;
                    if (!isValid) {
                        throw 'La cantidad debe ser positiva.';
                    }
                    isValid = x.permiteDecimales || validarInt(value);
                    if (!isValid) {
                        throw 'La cantidad no debe tener decimales.';
                    }
                    if (x.permiteDecimales && countDecimals(parseFloat(value)) > this.props.cantidadDecimales) {
                        throw `La cantidad no debe tener más de ${this.props.cantidadDecimales} decimales.`;
                    }
                    isValid = value <= x.solicitado;
                    if (!isValid) {
                        throw `La cantidad auditada supera la cantidad solicitada: ${formatearCantidad(x.solicitado, x.permiteDecimales, this.props.cantidadDecimales)}`;
                    }

                    let decimalValue = parseFloat(value);
                    x.editado = true;
                    x.estadoAuditoria = "PE";
                    x.seleccionPreparar = decimalValue;
                }
            });

            this.props.modificarOrdenSeleccionada(orden);
        } catch (e) {
            Notificacion.error(e);
        }
    }

    onClickAuditarProducto = (sucursalId, producto) => {
        try {
            if (producto.seleccionPreparar < 0 || producto.seleccionPreparar > producto.solicitado) {
                Notificacion.error("Introduzca una cantidad entre cero y la cantidad solicitada.");
                this.modificarCantidadProducto(producto, producto.seleccionPreparar - producto.solicitado, "restar");
                return;
            }

            if (!producto.permiteDecimales && !!(producto.seleccionPreparar % 1)) {
                Notificacion.error(`El artículo no permite cantidades con decimales.`);
                this.modificarCantidadProducto(producto, producto.seleccionPreparar - producto.solicitado, "restar");
                return;
            }

            this.props.auditarProducto(sucursalId, producto.id, producto.seleccionPreparar, null);
        } catch (e) {
            Notificacion.error(e);
        }
    };

    modificarCantidadProducto = (producto, unidades, accion) => {
        try {
            let orden = Object.assign({}, this.props.seleccion.orden);
            orden.productos.forEach(x => {
                if (JSON.stringify(x) === JSON.stringify(producto)) {
                    //  Hacer editables los productos de la orden seleccionada
                    x.estadoAuditoria = "PE";
                    x.editado = true;

                    if (accion === "sumar") {

                        if (this.props.validarArticuloDespacho && !producto.Detalle_Articulo_Validado) {
                            this.setState({ showModalValidacion: true, codigoValidar: '', articuloActual: producto.id });
                            return;
                        }

                        if ((x.seleccionPreparar + unidades) <= producto.solicitado) {
                            x.seleccionPreparar = parseFloat((x.seleccionPreparar + unidades).toFixed(x.permiteDecimales ? this.props.cantidadDecimales : 0));
                        } else {
                            throw "No puede exceder la cantidad solicitada.";
                        }
                    }
                    if (accion === "restar") {
                        if ((x.seleccionPreparar - unidades) >= 0) {
                            x.seleccionPreparar = parseFloat((x.seleccionPreparar - unidades).toFixed(x.permiteDecimales ? this.props.cantidadDecimales : 0));
                        } else {
                            throw "Ingrese una cantidad mayor a cero.";
                        }
                    }
                }
            });

            this.props.modificarOrdenSeleccionada(orden);
        } catch (e) {
            Notificacion.error(e);
        }
    }

    onChangeConfirmoLectura = (event) => {
        const { checked } = event.target;
        this.setState({ confirmoLectura: checked });
    }

    onClickAplicar = () => {
        if (this.props.seleccion && this.props.seleccion.orden && this.props.seleccion.orden.Instrucciones_Entrega && !this.state.confirmoLectura) {
            Notificacion.error("Debe confirmar la lectura de las instrucciones de entrega.");
        }
        else {
            this.props.toggleModal("picking", true)
        }
    }

    //VALIDACION CODIGO ARTICULO

    modificar_detalle_articulo_validado = async () => {

        const respuesta = await Modificar_Detalle_Orden_Articulo_Validado_Request(this.props.token, this.props.empresa.Id, this.props.filtro.ordenSucursalFactura.selected, this.props.seleccion.orden.Orden_Id, this.props.callCenter.Id, this.state.articuloActual);
        if (respuesta.Exitoso) {

            let orden = Object.assign({}, this.props.seleccion.orden);
            const indexItem = orden.productos.findIndex(item => item.id === this.state.articuloActual);
            if (indexItem >= 0) {
                orden.productos[indexItem].Detalle_Articulo_Validado = true;

                const item = orden.productos[indexItem];

                if ((item.seleccionPreparar + 1) <= item.solicitado) {
                    orden.productos[indexItem].seleccionPreparar = parseFloat((item.seleccionPreparar + 1).toFixed(item.permiteDecimales ? this.props.cantidadDecimales : 0));
                } else {
                    Notificacion.error("No puede exceder la cantidad solicitada.");
                }

                this.props.modificarOrdenSeleccionada(orden);
            }

            this.onCloseModalValidacion();
        }
        else {
            if (respuesta.CodigoError === 2) {
                Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                this.props.history.replace(SiteRutas.Login);
                return;
            }
            Notificacion.error('Error: ' + respuesta.Mensaje);
        }
    }

    validar_Articulo_Despacho = async () => {
        const respuesta = await Validar_Articulo_Despacho_Request(this.props.token, this.props.empresa.Id, this.state.articuloActual, this.state.codigoValidar);
        if (respuesta.Exitoso) {
            if (respuesta.Datos) {
                this.modificar_detalle_articulo_validado();
            }
            else {
                Notificacion.error('Error: El código no corresponde al artículo.');
            }
        }
        else {
            if (respuesta.CodigoError === 2) {
                Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                this.props.history.replace(SiteRutas.Login);
                return;
            }
            Notificacion.error(`Error: ${respuesta.Mensaje}`);
        }
    }

    onClickBtnValidar = () => {
        this.validar_Articulo_Despacho();
    }

    onCloseModalValidacion = () => {
        this.setState({ showModalValidacion: false, codigoValidar: '', articuloActual: '' });
    }

    onChangeCodigoValidacion = (event) => {
        const { value } = event.target;
        this.setState({ codigoValidar: value });
    }

    onKeyDownCodigoValidacion = (event) => {
        const { value } = event.target;
        const code = event.which ? event.which : event.keyCode;
        if (code === 13) {
            this.setState({ codigoValidar: value }, () => {
                this.validar_Articulo_Despacho();
            });
        }
    };

    render() {
        const { confirmoLectura, showModalValidacion, codigoValidar } = this.state;
        const { filtro, seleccion, cargando } = this.props;

        let orden = seleccion.orden;

        return (
            <>
                <Card className="picking-filter" style={{ marginTop: "20px" }}>
                    <Card.Body>
                        <Container className="mb-3">
                            <Row>
                                <Col xs={12} md="auto" className="mb-2">
                                    <Form.Control disabled={cargando} value={filtro.ordenSucursalFactura.selected} name="ordenSucursalFactura" as="select" onChange={(e) => { this.props.actualizarFiltro(e); }}>
                                        {
                                            filtro.ordenSucursalFactura.options.map((option) => <option key={option.Suc_Id} value={option.Suc_Id}>{option.Nombre}</option>)
                                        }
                                    </Form.Control>
                                </Col>
                                <Col xs={6} md="auto" className="mb-2">
                                    <span>{orden.estatus === "aplicada" ? "Preparada" : "Pendiente"}</span>
                                </Col>
                                {
                                    orden.Orden_Suc_Factura != filtro.ordenSucursalFactura.selected ?
                                        <Col xs={6} md="auto" className="mb-2">
                                            <span>{orden.traslado ? `Traslado #${orden.traslado}` : "Cargando número de traslado..."}</span>
                                        </Col>
                                        : null
                                }
                                {
                                    orden.Instrucciones_Entrega ?
                                        <div className="col-12 col-md mb-3">
                                            <p><b>Instrucciones de Entrega: </b>{orden.Instrucciones_Entrega}</p>
                                            <div className="custom-control custom-checkbox ml-0 mt-3">
                                                <input type="checkbox"
                                                    className="custom-control-input"
                                                    id="chkConfirmoLectura"
                                                    checked={confirmoLectura}
                                                    onChange={this.onChangeConfirmoLectura}
                                                />
                                                <label class="custom-control-label bold" htmlFor="chkConfirmoLectura">
                                                    Confirmo lectura de instrucciones
                                                </label>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    orden.estatus === "pendiente" &&
                                    <div className={`col-12 col-md${orden.Instrucciones_Entrega ? '' : '-2'} text-right`}>
                                        <Button disabled={cargando} variant="primary" onClick={this.onClickAplicar}>
                                            {cargando ? <><i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} /> Cargando...</> : "Aplicar"}
                                        </Button>
                                    </div>
                                }
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>
                <div className="picking-ordenes">
                    <Container>
                        <div className="row mt-4">
                            <div className="col">
                                <h3>Artículos</h3>
                            </div>
                            {
                                orden.estatus === "aplicada" || this.props.seleccion.prepararOrden ?
                                    null
                                    :
                                    <div className="col">
                                        {orden.productos.length > 0 && <button className="btn btn-preparar text-overflow-ellipsis" disabled={cargando} onClick={() => this.props.setPrepararOrden(true)}>{cargando ? <><i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} /> Cargando...</> : "Preparar Orden"}</button>}
                                    </div>
                            }
                        </div>
                        {
                            this.props.seleccion.prepararOrden ?
                                <div className="row">
                                    <div className="col-md-4 col-sm-12 col-xs-12 col-lg-4">
                                        <select className="form-control" onChange={(e) => { this.setState({ filtroArticulos: { ...this.state.filtroArticulos, selected: e.target.value } }); }} value={this.state.filtroArticulos.selected}>
                                            {
                                                this.state.filtroArticulos.options.map((option, i) => {
                                                    return <option key={i} value={option.value}>{option.label}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                :
                                null
                        }
                        <div className={`row ${this.state.filtroArticulos.selected === "ubicacion" ? "mt-4" : ""}`}>
                            <div className="col">
                                {
                                    orden.productos && Array.isArray(orden.productos) ?
                                        orden.productos.length > 0 && tarjetaArticulo(orden, cargando, this.state.filtroArticulos.selected, this.props.filtro.ordenSucursalFactura.selected, this.onClickAuditarProducto, this.modificarCantidadProducto, this.modificarCantidadProducto, this.onChangeCantidadProducto, this.props.onClickLotes, this.props.sucursalAplicaLotes, this.props.seleccion.prepararOrden, this.props.validarArticuloDespacho)
                                        :
                                        <p>No hay artículos disponible para la Orden en esta sucursal. </p>
                                }
                                {
                                    Array.isArray(orden.productos) && orden.productos.length == 0 ? <p>No hay artículos disponible para la Orden en esta sucursal. </p> : ""
                                }
                            </div>
                        </div>
                    </Container>
                </div>
                <Modal show={showModalValidacion} onHide={this.onCloseModalValidacion} keyboard={false} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title><h5 className="modal-title">Confirmación de código de artículo</h5></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12">
                                <Form.Group>
                                    <Form.Label>Código</Form.Label>
                                    <InputGroup className="mb-3">
                                        <FormControl
                                            placeholder="Código de artículo"
                                            aria-label="Código de artículo"
                                            aria-describedby="basic-addon2"
                                            maxLength="25"
                                            value={codigoValidar}
                                            onChange={this.onChangeCodigoValidacion}
                                            onKeyDown={this.onKeyDownCodigoValidacion}
                                        />
                                        <InputGroup.Append>
                                            <Button onClick={this.onClickBtnValidar} variant="primary">
                                                <FontAwesomeIcon icon={faCheck} size={2} />
                                            </Button>
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Form.Group>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={this.onCloseModalValidacion}>
                            Salir
                        </button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
};

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter,
        sucursal: state.parametros.sucursal
    };
};

export default connect(mapStateToProps)(withRouter(memo(PickingDetalle)));